module.exports = "/_next/static/images/basquiat-painting-38c32dde2ac134a0d15d3daaa0567cd0.png";